import FeedbackBox from "../Feedback";

export function QuestionCard({
  index,
  question,
  attempt,
  correctAnswer,
  studentAnswer,
  checkQuestion,
  status,
  mark,
  children,
}) {
  return (
    <div className="eval-card">
      {/* LEFT: Question + Answers */}
      <div className="eval-card__main">
        <div className="eval-card__header">
          <span className="eval-card__qno">Question {index}</span>
        </div>

        {children}

        <div className={`eval-card__student ${status}`}>
          <div className="label">Student Answer</div>
          {studentAnswer.text ? <p>{studentAnswer.text}</p> : null}
          {studentAnswer.file ? (
            <a href={studentAnswer.file.link} target="_blank" rel="noreferrer">
              📄 View File: {studentAnswer.file.name}
            </a>
          ) : null}
          {!studentAnswer.text && !studentAnswer.file ? (
            <p>{"No answer provided"}</p>
          ) : null}
        </div>

        {/* Correct Answer */}
        <div className="eval-card__correct">
          <div className="label">Correct Answer</div>
          <p dangerouslySetInnerHTML={{__html:correctAnswer}}></p>
        </div>
      </div>

      {/* RIGHT: Evaluation Panel */}
      <div className="eval-card__side">
        <FeedbackBox
          defaultStatus={attempt?.status}
          defaultMarks={attempt?.marks}
          defaultFeedback={attempt?.feedback}
          maxMarks={mark}
          onChange={(data) => checkQuestion(question._id, data)}
          id={question._id}
        />
      </div>
    </div>
  );
}
